export default __webpack_public_path__ + "static/media/Jets.4fa167ff.png";